import React from 'react';

export const SyncedIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.97695 14.3264L18.2305 6L20 7.88855L9.97695 18L3 10.9615L4.76948 9.07297L9.97695 14.3264Z"
      fill="currentColor"
    />
  </svg>
);
export const ProfileIcon = () => (
  <svg width={13} height={13} fill="none" viewBox="0 0 10 10">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 .41A.41.41 0 01.41 0h3.68a.41.41 0 01.41.41v9.18a.41.41 0 01-.41.41H.41A.41.41 0 010 9.59V.41zm5.5 0A.41.41 0 015.91 0h3.68a.41.41 0 01.41.41v2.68a.41.41 0 01-.41.41H5.91a.41.41 0 01-.41-.41V.41zm.41 4.09a.41.41 0 00-.41.41v4.68c0 .227.183.41.41.41h3.68a.41.41 0 00.41-.41V4.91a.41.41 0 00-.41-.41H5.91z"
      clipRule="evenodd"
    />
  </svg>
);

export const OutOfSyncIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9918 6.2483C9.33676 6.2483 7.13149 8.30632 6.69656 11.0111H5.51434C5.96 7.61402 8.69026 5 11.9918 5C14.3712 5 16.4539 6.35773 17.5985 8.3878V5.99864L19.0002 5.99864V10.9918H18.4667H17.5985H17.2839H14.7952V9.49388L16.8318 9.49388C15.9627 7.57313 14.122 6.2483 11.9918 6.2483ZM12.0084 19.0003C15.3037 19.0003 18.0298 16.3962 18.4833 13.0085H17.3005C16.8582 15.7038 14.6571 17.752 12.0084 17.752C9.87814 17.752 8.03744 16.4271 7.16835 14.5064H9.20503V13.0085H5.16966V13.0084H5L5 18.0016H6.40168L6.40168 15.6125C7.54628 17.6425 9.62897 19.0003 12.0084 19.0003Z"
      fill="currentColor"
    />
  </svg>
);
